import { setWithExpiry, getWithExpiry } from '@/utilities/helpers';
import { API } from '@/utilities/api';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import { PinchZoom } from '@/components/pinchZoom';

const Toast = Swal.mixin({
    toast: true,
    position: 'bottom-right',
    iconColor: 'white',
    customClass: {
        popup: 'colored-toast',
    },
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
})


/**
 * 
 *  Topic filtering functionality
 * 
 */
export class Images {

    /**
     * 
     * Contructor
     * 
     * @param {element} list - The list element to filter the suggestions into
     * @param {element} input - The input element to get the user query from
     * @param {element} clear_filters - The button to clear all of the selected search inputs
     * @param {element} search_info - The x of y search info box
     */
    constructor(grid, input, clear_filters, search_info) {

        this.query = '';
        this.images = undefined;
        this.modal_images = undefined;
        this.filtered_images = [];
        this.grid = grid;
        this.page_limit = 48;
        this.current_page = 1;
        this.current_index = 0;
        this.pages = 0;
        this.filters = [];
        this.input = input;
        this.clear_filters = clear_filters;
        this.search_info = search_info;



        // Initialise the suggestion box interactions
        this.init();

    }


    /**
    * 
    * Show the gallery modal
    * 
    */
    show() {

        // Add the active class to the page
        document.body.classList.add('gallery-modal-open');

        // Set the visiblity state
        this.visible = true;

        console.log('ZOOM PICK - IMAGES');
        if (this.zoomPick) this.zoomPick.destroy();
        this.zoomPick = new PinchZoom(document.querySelector('.gallery-modal__wrap__images__item [zoomable]'));

    }


    /**
     * 
     * Initialise the suggestion box interactions
     * 
     */
    init() {

        let entity_id = document.body.dataset.keepEntityId;
        let entity_type = document.body.dataset.keepEntityType;

        // Fetch the list of images from a cached JSON file
        this.fetch();

        // close modal on escape key press
        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                document.body.classList.remove('gallery-modal-open');

                //Reset the zoom of the page
                window.resetZoom();

                document.body.classList.remove('copyright-visible');
            }
        });

        // Attach keyboard events to the checkbox input field
        document.querySelectorAll('.images__wrap__filters__section__keyword input').forEach((item) => {
            item.addEventListener('change', () => {
                this.filter();
            });
        });

        // Attach keyboard events to the input field
        this.input.addEventListener('keydown', (event) => {
            if (event.keyCode === 13) event.preventDefault();
        });


        // Attach keyboard events to the input field
        this.input.addEventListener('keyup', () => {
            // Set a timeout on the filter section 
            setTimeout(() => this.filter(), 50);
        });

        // Fetch the list of images on initial focus
        this.input.addEventListener('focus', () => {
            if (!this.images) this.fetch();
        });

        // Fetch the list of images on initial focus
        this.clear_filters.addEventListener('click', (event) => {
            event.preventDefault();
            this.clear();
        });

        document.addEventListener('click', (event) => {
            if (event.target.classList.contains('js-images-image')) {
                event.preventDefault();

                // Clean up any pre existing modals
                this.clean();

                // If this is a sensitive image, then we should remove the sensitive-image class
                if (event.target.classList.contains('sensitive-image')) {
                    event.target.classList.remove('sensitive-image');
                }

                // Otherwise we should open the modal 
                else {

                    // Get index of clicked item
                    let grid_item = event.target.parentElement.parentElement;
                    this.current_index = parseInt(grid_item.dataset.index);

                    // Append the template to the end of the page
                    document.body.insertAdjacentHTML('beforeend', this.templateModal(this.current_index));

                    // Show the modal after a short delay
                    setTimeout(() => this.show(), 100);
                }

            }


            if (event.target.classList.contains('js-toggle-image-favourite')) {
                let entity_id = event.target.dataset.entityId;
                let entity_type = 'image';

                API.toggle_favourites({ entity_id, entity_type })
                    .then((response) => {

                        event.target.classList.toggle('hearted');

                        if (response.status !== 'ok' || response.message === 401) {
                            event.target.classList.remove('hearted');
                        }

                        // Toast.fire({
                        //     icon: (response.status === 'ok') ? 'success' : 'error',
                        //     title: (response.message !== 401) ? response.message : 'You need to be logged in as a pro member to favourite images'
                        // });
                    });


            }

            if (event.target.matches('.gallery-modal__wrap__previous')) {
                event.preventDefault();
                this.previousImage();
            }

            if (event.target.matches('.gallery-modal__wrap__next')) {
                event.preventDefault();
                this.nextImage();
            }

            if (event.target.matches('.images__wrap__grid__pagination__first') || event.target.matches('.images__wrap__grid__pagination__first img')) {
                event.preventDefault();
                this.paginate('previous');
            }

            if (event.target.matches('.images__wrap__grid__pagination__pages__item')) {
                event.preventDefault();
                this.paginate(parseInt(event.target.dataset.page))
            }

            if (event.target.matches('.images__wrap__grid__pagination__last') || event.target.matches('.images__wrap__grid__pagination__last img')) {
                event.preventDefault();
                this.paginate('next');
            }
            if (event.target.matches('.gallery-modal') && event.target.contains(document.querySelector('.gallery-modal__wrap'))) {
                event.preventDefault();
                document.body.classList.remove('gallery-modal-open');

                //Reset the zoom of the page
                window.resetZoom();

                document.body.classList.remove('copyright-visible');
            }

        });

        setTimeout(() => {

            // Get the URL parameters
            let url_filters = new URLSearchParams(window.location.search);

            // Set the individual filters and search functions
            for (const [key, value] of url_filters.entries()) {
                if (key === 'query') {
                    document.querySelector('.js-images-input').value = value;
                    this.filter();
                }

                if (key === 'filters') {
                    value.split(',').forEach((item) => {
                        let $checkbox = document.querySelector(`.images__wrap__filters__section__keyword input[value="${item}"]`);

                        if ($checkbox) {
                            $checkbox.checked = true;
                            $checkbox.closest('.images__wrap__filters__section').classList.add('expanded')
                        }
                    });
                    this.filter();
                }
            }

            // Smopoth scroll to the top of the topics div
            if (url_filters.has('query') || url_filters.has('filters')) {
                // Scroll down to the map element on select action
                window.scroll({
                    behavior: 'smooth',
                    left: 0,
                    top: document.querySelector('.images').offsetTop + 40
                });
            }

        }, 500);


    }

    /**
    * 
    * Navigate to the previous image
    * 
    */
    previousImage() {

        // Remove the active class from the copyright element
        document.body.classList.remove('copyright-visible');

        // Update the current index
        (this.current_index <= 0) ? this.current_index = 0 : this.current_index--;

        // Update the modal
        document.querySelector('.gallery-modal__wrap__images').innerHTML = this.image_template([...this.modal_images][this.current_index]);

    }

    /**
    * 
    * Navigate to the next image
    * 
    */
    nextImage() {

        // Remove the active class from the copyright element
        document.body.classList.remove('copyright-visible');

        // Update the current index
        (this.current_index === this.page_limit - 1) ? this.current_index = 0 : this.current_index++;

        // Update the modal
        document.querySelector('.gallery-modal__wrap__images').innerHTML = this.image_template([...this.modal_images][this.current_index]);

        console.log('ZOOM PICK - IMAGES');
        if (this.zoomPick) this.zoomPick.destroy();
        this.zoomPick = new PinchZoom(document.querySelector('.gallery-modal__wrap__images__item [zoomable]'));

    }


    /**
     * 
     * Navigate to the previous image
     * 
     */
    prevImage() {

        // Remove the active class from the copyright element
        document.body.classList.remove('copyright-visible');

        // Update the current index
        (this.current_index === 0) ? this.current_index = this.images.length - 1 : this.current_index--;

        // Update the modal
        document.querySelector('.gallery-modal__wrap__images').innerHTML = this.image_template([...this.images][this.current_index]);

        console.log('ZOOM PICK - IMAGES');
        if (this.zoomPick) this.zoomPick.destroy();
        this.zoomPick = new PinchZoom(document.querySelector('.gallery-modal__wrap__images__item [zoomable]'));

    }


    /**
     * 
     * Remove any pre existing gallery modals
     * 
     */
    clean() {
        document.querySelector('.gallery-modal') ? document.querySelector('.gallery-modal').remove() : null;
    }


    clear() {

        // Clear the query
        this.query = '';

        // Clear the query input field
        this.input.value = '';

        // Clear the checkbox filters
        document.querySelectorAll('.images__wrap__filters__section__keyword input').forEach((item) => {
            item.checked = false;
        });

        // Show/hide the clear filters button bsed on search parameters being present
        this.clear_filters.classList[this.query.length ? 'add' : 'remove']('active');

        // Update the search info box
        this.search_info.innerHTML = (this.query.length) ? `Showing ${this.filtered_topics.length} of ${this.topics.length} topics` : '';

        // Show/hide the search info box based on search parameters being present
        this.search_info.classList[this.query.length ? 'add' : 'remove']('active');


        // Set a timeout on the filter section 
        setTimeout(() => this.filter(), 50);
    }


    /**
     * 
     *  Fetch a list of predefined search terms from a JSON file images
     * 
     */
    fetch() {

        this.images = window.initial_images;

        this.render();

        if (getWithExpiry('dermnet_images')) {
            this.images = JSON.parse(getWithExpiry('dermnet_images'));

            // Update the search input placeholder once the JSON has loaded
            this.input.setAttribute('placeholder', `Search images`);

            // Remove the spinning loader
            this.input.parentElement.querySelector('.spinning-loader').remove();

        } else {

            // Fetch a pre cached JSON file from our CDN
            fetch('/assets/___cache/images.json?v=1.0.2')
                .then((response) => response.text())
                .then(data => {
                    setWithExpiry('dermnet_images', data);
                    this.images = JSON.parse(data);

                    // Update the search input placeholder once the JSON has loaded
                    this.input.setAttribute('placeholder', `Search images`);

                    // Remove the spinning loader
                    this.input.parentElement.querySelector('.spinning-loader').remove();
                });
        }

    }


    /**
     * 
     * Fetch a list of checked filters
     * 
     */
    getFilters() {
        this.filters = [];
        document.querySelectorAll('.images__wrap__filters__section').forEach((section) => {
            section.querySelectorAll('input').forEach((item) => {
                if (item.checked) {
                    this.filters[section.dataset.section] = this.filters[section.dataset.section] || [];
                    this.filters[section.dataset.section].push(item.value);
                }
            });
        });
    }

    /**
     * 
     * Filter a list of predefined search terms based on user input
     * 
     */
    filter() {

        // Fetch the list of checked filters
        this.getFilters();

        // Reset the current page
        this.current_page = 0;

        // Update the query to match what a user has typed
        this.query = this.input.value.trim();

        // if this.query contains any quotes, then we should split the query into an array and search for exact terms
        if (/["']/.test(this.query)) {
            let words = this.query.split(' ');
            let quotedWords = words.filter(word => word.startsWith('"') && word.endsWith('"') || word.startsWith("'") && word.endsWith("'"));
            quotedWords = quotedWords.map(word => word.replace(/['"]+/g, ''));
            quotedWords.forEach(word => {
                // Filter the list of images based on the query 
                this.filtered_images = this.images.filter(item => {
                    return item.a?.toLowerCase().split(' ').includes(word.toLowerCase()) || item.b?.toLowerCase().split(' ').includes(word.toLowerCase()) || item.c?.toLowerCase().split(' ').includes(word.toLowerCase()) || item.i?.toLowerCase().split(' ').includes(word.toLowerCase())
                });
            });

            // get a list of un quoted words
            let unquotedWords = words.filter(word => !word.startsWith('"') && !word.endsWith('"') && !word.startsWith("'") && !word.endsWith("'"));
            unquotedWords.forEach(word => {
                // Filter the list of images based on the query 
                this.filtered_images = this.filtered_images.filter(item => item.a?.toLowerCase().includes(word.toLowerCase()) || item.b?.toLowerCase().includes(word.toLowerCase()) || item.c?.toLowerCase().includes(word.toLowerCase()) || item.i?.toLowerCase().includes(word.toLowerCase()));
            });

        } else {
            // Filter the list of images based on the query 
            this.filtered_images = this.images.filter(item => item.a?.toLowerCase().includes(this.query.toLowerCase()) || item.b?.toLowerCase().includes(this.query.toLowerCase()) || item.c?.toLowerCase().includes(this.query.toLowerCase()) || item.i?.toLowerCase().includes(this.query.toLowerCase()));
        }


        // Filter the list of images based on the selected filters
        if (this.filters) {


            // Filter the list of images based on the selected filters
            // loop filter collection
            for (const [key, value] of Object.entries(this.filters)) {
                this.filtered_images = this.filtered_images.filter(image => {

                    // If there ware no keywords, then we should return false
                    if (!image?.c) return false;

                    // Assign our keywords array
                    let image_keywords = (image?.c) ? image.c.split(',') : [];

                    if (key === 'age') {
                        return image_keywords.some(keyword => {
                            return value.some(filter => {
                                if (filter === '0-5') {
                                    return (keyword.toLowerCase().trim() === filter.toLowerCase().trim()) || /(?:^|[^0-9])(1|2|3|4|5)(?:[^0-9]|$)/.test(keyword.toLowerCase().trim()) && (keyword.toLowerCase().trim()).includes('year');
                                }
                                else if (filter === '6-9') {
                                    return (keyword.toLowerCase().trim() === filter.toLowerCase().trim()) || /(?:^|[^0-9])(6|7|8|9)(?:[^0-9]|$)/.test(keyword.toLowerCase().trim()) && (keyword.toLowerCase().trim()).includes('year');
                                }
                                else if (filter === '10-19') {
                                    return (keyword.toLowerCase().trim() === filter.toLowerCase().trim()) || /(?:^|[^0-9])(10|11|12|13|14|15|16|17|18|19)(?:[^0-9]|$)/.test(keyword.toLowerCase().trim()) && (keyword.toLowerCase().trim()).includes('year');
                                }
                                else if (filter === '20-29') {
                                    return (keyword.toLowerCase().trim() === filter.toLowerCase().trim()) || /(?:^|[^0-9])(20|21|22|23|24|25|26|27|28|29)(?:[^0-9]|$)/.test(keyword.toLowerCase().trim()) && (keyword.toLowerCase().trim()).includes('year');
                                }
                                else if (filter === '30-39') {
                                    return (keyword.toLowerCase().trim() === filter.toLowerCase().trim()) || /(?:^|[^0-9])(30|31|32|33|34|35|36|37|38|39)(?:[^0-9]|$)/.test(keyword.toLowerCase().trim()) && (keyword.toLowerCase().trim()).includes('year');
                                }
                                else if (filter === '40-49') {
                                    return (keyword.toLowerCase().trim() === filter.toLowerCase().trim()) || /(?:^|[^0-9])(40|41|42|43|44|45|46|47|48|49)(?:[^0-9]|$)/.test(keyword.toLowerCase().trim()) && (keyword.toLowerCase().trim()).includes('year');
                                }
                                else if (filter === '50-59') {
                                    return (keyword.toLowerCase().trim() === filter.toLowerCase().trim()) || /(?:^|[^0-9])(50|51|52|53|54|55|56|57|58|59)(?:[^0-9]|$)/.test(keyword.toLowerCase().trim()) && (keyword.toLowerCase().trim()).includes('year');
                                }
                                else if (filter === '60-69') {
                                    return (keyword.toLowerCase().trim() === filter.toLowerCase().trim()) || /(?:^|[^0-9])(60|61|62|63|64|65|66|67|68|69)(?:[^0-9]|$)/.test(keyword.toLowerCase().trim()) && (keyword.toLowerCase().trim()).includes('year');
                                }
                                else if (filter === '70+') {
                                    return (keyword.toLowerCase().trim() === filter.toLowerCase().trim()) || /(?:^|[^0-9])(70|71|72|73|74|75|76|77|78|79|80|81|82|83|84|85|86|87|88|89|90|91|92|93|94|95|96|97|98|99|100)(?:[^0-9]|$)/.test(keyword.toLowerCase().trim()) && (keyword.toLowerCase().trim()).includes('year');
                                }
                                else {
                                    return filterOverride(keyword.toLowerCase().trim(), filter.toLowerCase().trim())
                                }
                            });
                        });

                    } else {
                        return image_keywords.some(keyword => {
                            return value.some(filter => {
                                return keyword.toLowerCase().trim() === filter.toLowerCase().trim();
                            });
                        });
                    }


                });
            };

        }

        // Show/hide the clear filters button based on search parameters being present
        this.clear_filters.classList[this.query.length || Object.keys(this.filters).length !== 0 ? 'add' : 'remove']('active');

        // Update the search info box
        this.search_info.innerHTML = (this.query.length || Object.keys(this.filters).length !== 0) ? `Showing ${this.filtered_images.length} of ${this.images.length} images` : '';

        // Show/hide the search info box based on search parameters being present
        this.search_info.classList[this.query.length || Object.keys(this.filters).length !== 0 ? 'add' : 'remove']('active');

        // Sort the list of images
        this.sort();

        // Render the list of suggestions
        this.render();

    }


    /**
     * 
     * Rudimentary sorting function that boosts based on title, headline then keywords and sorts the resulting collection
     * 
     */
    sort() {

        this.filtered_images.forEach((item) => {
            item.boost = 0;

            // If the image has a title that matches the query, then we should boost it
            if (item.a?.toLowerCase().includes(this.query.toLowerCase())) item.boost += 100;

            // If the image has a subject code that matches the query, then we should boost it
            if (item.i?.toLowerCase().includes(this.query.toLowerCase())) item.boost += 75;

            // If the image has a headline that matches the query, then we should boost it
            if (item.b?.toLowerCase().includes(this.query.toLowerCase())) item.boost += 50;

            // If the image has a keyword that matches the query, then we should boost it
            if (item.c?.toLowerCase().includes(this.query.toLowerCase())) item.boost += 25;

        });

        // Sort the images based on their boost
        this.filtered_images.sort((a, b) => b.boost - a.boost);

    }

    /**
     * 
     * Shuffle the initial images on page load so users see a different image set
     * 
     */
    shuffleImages(images_array) {

        // Set the index to the arrays length
        let i = images_array.length, temp_item, alternate_item;

        // Create a loop that subtracts everytime it iterates through
        while (--i > 0) {
            // Create a random number and store it in a variable
            temp_item = Math.floor(Math.random() * (i + 1));

            // Create a temporary position from the item of the random number    
            alternate_item = images_array[temp_item];
            // Swap the temp with the position of the last item in the images_array    

            images_array[temp_item] = images_array[i];
            // Swap the last item with the position of the random number 

            images_array[i] = alternate_item;
        }
        return images_array;
    }

    /**
     * 
     * Render out the list of suggestions
     * 
     * @param {string} html - HTML template initialiser
     */
    render(html = '', advert_index = 1) {

        // Reset the modal images
        this.modal_images = [];

        // Update the number of pages
        this.pages = Math.ceil(this.filtered_images.length / this.page_limit);

        // Render the nominal state if there are no images or if there are no filters
        if (this.images.length === 60 || this.filtered_images.length === this.images.length) {
            this.pages = Math.ceil(window.initial_images.length / this.page_limit);
            this.filtered_images = this.shuffleImages(window.initial_images);
        }

        // Render out the images based on their position in the collection
        [...Array(this.page_limit).keys()].map((item, index) => {

            // Get the starting position of the images
            let itemIndex = index + this.current_page * this.page_limit;

            // Add an advert after the nth image
            if (this.filtered_images[itemIndex] && window.show_ads == '1') if (index === 5 || index === 8 || index === 15 || index === 18 || index === 25 || index === 28 || index === 35 || index === 38 || index === 45) html += this.advert(advert_index++);

            // Only add it to the HTML if it exists and we haven't looped nothing
            if (this.filtered_images[itemIndex]) html += this.template(this.filtered_images[itemIndex], index)

            // Add the image to the modal images
            if (this.filtered_images[itemIndex]) this.modal_images.push(this.filtered_images[itemIndex])

        });

        // Render the pagination if needed
        if (html) html += this.pagination(this.pages, this.current_page);

        // Render the HTML
        this.grid.innerHTML = (html === '') ? this.empty() : html;

        // Render the advertisements
        if (this.grid.querySelectorAll('.advertisement')) {

            // Initialise the adpushup object
            var adpushup = window.adpushup = window.adpushup || {};
            adpushup.que = adpushup.que || [];

            // Loop through the advertisements and trigger them
            this.grid.querySelectorAll('.advertisement').forEach((item) => {
                adpushup.que.push(function () {
                    adpushup.triggerAd("2d748d97-2d68-4e46-8bc1-6b0bc1d76fad");
                });
            });
        }

    }

    paginationItem = (page, currentPage, pages) => {
        return /*html */`
        <button class="images__wrap__grid__pagination__pages__item ${(page === currentPage) ? 'active' : ''} ${(page >= pages) ? 'hidden' : ''}" data-page="${page}">${page + 1}</button>`
    }

    pagination(pages, currentPage) {
        return /*html */`
        <div class="images__wrap__grid__pagination"  style="${(pages === 1) ? `display:none;` : `display:flex;`}">
            <button class="images__wrap__grid__pagination__first">
                <img src="_resources/themes/mercury/dist/images/svg/arrow-left-medium-blue.svg" width="26" height="26" loading="lazy" alt="medium-arrrow-left-black">
            </button>
            ${[...Array((pages > 5) ? 5 : pages).keys()].map((item, index) => this.paginationItem((currentPage > 3 && pages > 5) ? index - 2 + currentPage : index, currentPage, pages)).join('')}
            <button class="images__wrap__grid__pagination__last">
                <img src="_resources/themes/mercury/dist/images/svg/arrow-right-medium-blue.svg" width="26" height="26" loading="lazy" alt="medium-arrrow-right-black">
            </button>
        </div>`
    }

    paginate(page) {

        // Update the current page based on the clicked element
        if (page === 'previous') {
            (this.current_page > 0) ? this.current_page-- : this.current_page = 0;
        } else if (page === 'next') {
            (this.current_page < this.pages - 1) ? this.current_page++ : this.current_page = this.pages - 1;
        } else { this.current_page = page; }


        // Rrender the images
        this.render();

        // Scroll to the top of the grid
        window.scroll({
            behavior: 'smooth',
            left: 0,
            top: this.grid.offsetTop + 200
        });

    }

    /**
     * 
     * Mark a searched term in the list of images
     * 
     * @param {string} name 
     * @returns {string} template 
     */
    marked(name) {
        let regex = new RegExp(this.query, 'gi');
        return name.replace(regex, `<span class="marked">$&</span>`);
    }


    item(item) {
        return /*html*/`
        <a href="${item.g}">${this.marked(item.a)}</a>`;
    }

    advert(index) {
        return /*html*/`
        <div class="images__wrap__grid__item Ad-${index}">
            <section class="advertisement advertisement--300x250">
                <div class="advertisement__wrap">
                    <div class="advertisement__wrap__title">ADVERTISEMENT</div>
                    <div class="advertisement__wrap__content">

                    <div id="2d748d97-2d68-4e46-8bc1-6b0bc1d76fad" class="_ap_apex_ad" style="width: 300px; height: 250px;"></div>

                    </div>
                </div>
            </section>
        </div>`;
    }


    /**
    * 
    * No results template
    * 
    * @returns {string} template
    */
    empty() {
        return /*html*/`
        <div class="topics__wrap__grid__column topics__wrap__grid__column--full">
            <div class="topics__wrap__grid__column__heading">
                <h3 class="h2">No results found</h3>
                <hr>
            </div>
        </div>`;
    }


    /**
     * 
     * Single image template
     * 
     * @param {Node} image 
     * @returns {String} template
     */
    image_template(image) {

        let hearted = '';

        if (window.keeps) {
            let keep = window.keeps.data.find(keep => parseInt(keep.entity_id) === parseInt(image.o) && keep.entity_type === 'image');
            if (keep) hearted = 'hearted';
        }

        let image_source = (image.g?.includes('http')) ? `<a href="${image.g}">${image.g}</p>` : image.f;

        let keywords = (image.c) ? image.c.split(',').map((keyword, index, array) => `<a class="colour--primary" href="/images?query=${keyword}">${keyword}</a>${index < array.length - 1 ? ',' : ''}`).join(' ') : undefined;

        return /*html*/`
        <div class="gallery-modal__wrap__images__item">
            <div href="/imagedetail/${image.p}" target="_blank" class="gallery-modal__wrap__images__item__image" onclick="event.preventDefault();">
                <img zoomable draggable="false" class="[ js-gallery-image ]" src="${image.l}" width="640" height="480" loading="lazy" alt="${image.a}">
            </div> 
            <div class="images__wrap__grid__item__heart [ js-toggle-image-favourite ] ${hearted}" data-entity-id="${image.o}">
                <span class="heart">
                    <img class="heart__image-1" src="/_resources/themes/mercury/dist/images/svg/heart-red.svg" width="24" height="24" loading="lazy" alt="brown-heart">
                    <img class="heart__image-2" src="/_resources/themes/mercury/dist/images/svg/heart-full-red.svg" width="24" height="24" loading="lazy" alt="brown-heart">
                    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z" stroke="#ff5050" fill="none" fill-rule="evenodd" />
                    </svg>
                </span>
            </div>
            <div class="gallery-modal__wrap__images__item__caption">
                <div class="gallery-modal__wrap__images__item__caption__text">
                    <h3 class="colour--secondary"><b>${image.a}</b></h3>
                    <p class="no-margin colour--secondary ">${image.b || ''} ${(image.i) ? `<span style="opacity:0.5;">${image.i}</span>` : ``}</p>
                </div>
                <div class="gallery-modal__wrap__images__item__caption__footer">
                    <span class="no-margin colour--secondary smaller gallery-modal__wrap__images__item__caption__footer__keywords" style="width:100%">${keywords && `<b>Keywords:</b> ${keywords} `}</span>
                    <p class="no-margin colour--secondary smaller colour--grey-mid-dark">Source: ${(image_source || '')}</p>
                    <p class="no-margin colour--secondary smaller">
                        <a href="/terms" class="colour--grey-mid-dark">Terms and conditions</a>
                        <span class="colour--grey-mid-dark">&nbsp;|&nbsp;</span>
                        <a href="#" class="colour--primary" onclick="event.preventDefault();document.body.classList.toggle('copyright-visible')">Reusing this image</a>
                    </p>
                </div>
                
            </div>
            <div class="gallery-modal__wrap__images__item__copyright">
                <div class="gallery-modal__wrap__images__item__copyright__close" onclick="document.body.classList.remove('copyright-visible')">
                    <img src="_resources/themes/mercury/dist/images/svg/close.svg" width="10" height="10" loading="lazy" alt="close">
                </div>
                <p class="colour--white no-margin"><b>© DermNet.</b></p>
                <p class="colour--white smaller no-margin">You can use or share this image if you comply with our image <a href="/image-licence">licence</a>. Please provide a link back to this page. 
                <br><br>For a high resolution, unwatermarked copy contact us <a href="/permission/?image=${image.o}">here</a>. Fees apply.</p>
            </div>
        </div>`;
    }

    /**
     * 
     * Gallery modal template
     * 
     * @returns {String} template
     */
    templateModal(index) {
        this.current_index = index;

        return /*html*/` 
        <div class="gallery-modal">
            <div class="gallery-modal__wrap">
                <div class="gallery-modal__wrap__close" onclick="document.body.classList.remove('gallery-modal-open');document.body.classList.remove('copyright-visible');window.resetZoom();">
                    <img src="_resources/themes/mercury/dist/images/svg/close-dark-blue.svg" width="39px" height="40px" loading="lazy" alt="close">
                </div>
                <div class="gallery-modal__wrap__images">
                    ${this.image_template(this.modal_images[this.current_index])}
                </div>
                ${(this.modal_images.length > 1) ? /*html*/`
                <button class="gallery-modal__wrap__previous">
                    <img src="_resources/themes/mercury/dist/images/svg/arrow-left-medium-dark-blue.svg" width="39px" height="40px" loading="lazy" alt="Paginate to the previous image">
                </button>
                <button class="gallery-modal__wrap__next">
                    <img src="_resources/themes/mercury/dist/images/svg/arrow-right-medium-dark-blue.svg" width="39px" height="40px" loading="lazy" alt="Pagniate to the next image">
                </button>`
                : ``}
            </div>
        </div>`;
    }


    template(item, index) {

        let hearted = '';

        if (window.keeps) {
            let keep = window.keeps.data.find(keep => parseInt(keep.entity_id) === parseInt(item.o) && keep.entity_type === 'image');
            if (keep) hearted = 'hearted';
        }

        return /*html*/`
        <div class="images__wrap__grid__item" data-id="${item.o}" data-keywords="${item.c}" data-index="${index}">
            <div class="gallery__slides__item__image">
                <div class="load"></div>
                <img src="${item.l}" class="[ js-images-image ]${(item.e) ? `[ xsensitive-imagex ]` : ``}" width="640" height="480" loading="lazy" alt="${item.a}" onerror="this.classList.add('error')" data-title="${item.a}" data-headline="${item.b}" data-copyright="${item.f}" data-terms="${item.h}">
            </div> 
            <div class="images__wrap__grid__item__heart [ js-toggle-image-favourite ] ${hearted}" data-entity-id="${item.o}">
                <span class="heart">
                    <img class="heart__image-1" src="/_resources/themes/mercury/dist/images/svg/heart-red.svg" width="24" height="24" loading="lazy" alt="brown-heart">
                    <img class="heart__image-2" src="/_resources/themes/mercury/dist/images/svg/heart-full-red.svg" width="24" height="24" loading="lazy" alt="brown-heart">
                    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z" stroke="#ff5050" fill="none" fill-rule="evenodd" />
                    </svg>
                </span>
            </div>
            <div class="gallery__slides__item__caption">
                <p class="smaller no-margin colour--secondary">${item.b || item.a}${(item.i) ? `, <a href="/images?query='${item.i}'" style="opacity:0.5;">(${item.i})</a>` : ``}</p>
            </div>
        </div>`;
    }

}

/**
a:title
b:headline
c:keywords
d:description
e:is_sensitive
f:copyright
g:source
h:terms_of_use
i:subject_code
j:extension
k:size
l:thumbnail
m:link
n:filename
o:id
*/